export default "__VITE_ASSET__1494610d__"